import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_AR,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_WARNING,
} from "constants/FormatDataContanst";
import "flatpickr/dist/themes/material_blue.css";
import { TYPE_REPORT } from "pages/ReportInvoiceError/helper/functionHelper";
import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Progress,
  Row,
} from "reactstrap";
import {
  downloadReportInvoice,
  executeTaxDeductReport,
  getReportInvoiceProgress,
  resetExecuteTaxDeductReport,
  resetGetReportInvoiceProgress,
} from "store/summary-invoice-data/actions";
import {
  EXECUTE_TAX_DEDUCT_REPORT_FAIL,
  EXECUTE_TAX_DEDUCT_REPORT_SUCCESS,
} from "store/summary-invoice-data/actionTypes";

const DetailReport = props => {
  const { isOpenModal, dataDetail, toggleModal, resetListData } = props;
  const dispatch = useDispatch();
  // store reducer
  const summaryInvoiceData = useSelector(state => state.summaryInvoiceData);
  const {
    reportInvoiceProgress,
    type: typeReport,
    executeTaxDeductReportData,
    loadingDownload,
  } = summaryInvoiceData;

  const { addToast } = useToasts();

  useEffect(() => {
    if (isOpenModal) {
      dispatch(
        getReportInvoiceProgress(dataDetail?.id, true, TYPE_REPORT.TAX_DEDUCT)
      );
    } else {
      dispatch(resetGetReportInvoiceProgress());
    }
  }, [isOpenModal]);

  useEffect(() => {
    if (isOpenModal) {
      switch (typeReport) {
        case EXECUTE_TAX_DEDUCT_REPORT_SUCCESS: {
          addToast("Import đợt chứng từ thành công", {
            appearance: "success",
            autoDismiss: true,
          });
          dispatch(
            getReportInvoiceProgress(
              dataDetail?.id,
              true,
              TYPE_REPORT.TAX_DEDUCT
            )
          );
          dispatch(resetExecuteTaxDeductReport());
          break;
        }
        case EXECUTE_TAX_DEDUCT_REPORT_FAIL:
          addToast("Import đợt chứng từ thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
          dispatch(resetExecuteTaxDeductReport());
          break;
      }
    }
  }, [typeReport]);

  useEffect(() => {
    // Tiến độ 100% thì gọi query hóa đơn
    if (
      !reportInvoiceProgress.isStart &&
      reportInvoiceProgress?.percent === 100
    ) {
      // dispatch(invoiceCampaignDetail(dataDetail.id));
      resetListData && resetListData();
    }
  }, [reportInvoiceProgress]);

  const modal = useRef(null);

  return (
    <React.Fragment>
      <Modal
        isOpen={isOpenModal}
        toggle={toggleModal}
        size="xl"
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        contentClassName="detail-data-format"
        style={{ maxWidth: "99%" }}
      >
        <ModalHeader toggle={toggleModal}>Tiến Độ Xử Lý</ModalHeader>
        <React.Fragment>
          <ModalBody>
            <Row className="d-flex justify-content-center">
              <div style={{ width: "50vw" }}>
                <div
                  className="d-flex justify-content-center align-items-end gap-2"
                  style={{ fontSize: "17px" }}
                >
                  {/* <i className=" far fa-file-excel text-success font-size-20" /> */}
                  {/* <strong>{nameFile + ".xlsx "}</strong> */}
                  {reportInvoiceProgress.percent === 100
                    ? ""
                    : "(Đang xử lý dữ liệu)"}
                </div>
                <Progress
                  style={{ height: "33px" }}
                  animated
                  color={`${
                    reportInvoiceProgress.percent === 100
                      ? "success"
                      : "warning"
                  }`}
                  striped
                  value={reportInvoiceProgress.percent}
                >
                  <span style={{ fontSize: "20px" }}>
                    {reportInvoiceProgress.percent === 100 && "Hoàn tất xử lý"}{" "}
                    ({reportInvoiceProgress.percent + "%"})
                  </span>
                </Progress>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "15px",
                  justifyContent: "center",
                  fontSize: "18px",
                  marginTop: "10px",
                  lineHeight: "15px",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <div className="text-primary">
                  Id đợt chứng từ: {dataDetail?.id}
                </div>
                {reportInvoiceProgress?.reportDetail?.auth_status ===
                  AUTH_STATUS_APPROVE &&
                  reportInvoiceProgress?.percent === 100 && (
                    <h5
                      className="mt-2 text-info"
                      style={{
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                      onClick={() => {
                        window.open(
                          `/tax-deduct/list?report_id=${dataDetail?.id}`,
                          "_blank"
                        );
                      }}
                    >
                      Xem chứng từ
                    </h5>
                  )}
                {reportInvoiceProgress?.reportDetail?.auth_status ===
                  AUTH_STATUS_REJECT &&
                  reportInvoiceProgress?.percent === 100 && (
                    <div className="p-1">
                      <h5 className="mt-2 text-danger">Lỗi validate:</h5>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: reportInvoiceProgress?.reportDetail?.log,
                        }}
                      ></div>
                    </div>
                  )}
              </div>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              color="danger"
              className="me-2"
              onClick={toggleModal}
            >
              Đóng
            </Button>
            {(reportInvoiceProgress?.reportDetail?.auth_status ===
              AUTH_STATUS_AR ||
              reportInvoiceProgress?.reportDetail?.auth_status ===
                AUTH_STATUS_WARNING) &&
              reportInvoiceProgress?.percent === 100 && (
                <Button
                  color="info"
                  className="btn-label"
                  type="button"
                  disabled={executeTaxDeductReportData.loading}
                  onClick={() => {
                    dispatch(resetGetReportInvoiceProgress());
                    dispatch(executeTaxDeductReport(dataDetail?.id));
                  }}
                >
                  <i className="fas fa-file-import label-icon"></i>
                  Import đợt chứng từ
                </Button>
              )}
            <Button
              color="success"
              className="btn-label"
              type="button"
              disabled={loadingDownload}
              onClick={() => {
                dispatch(
                  downloadReportInvoice(
                    dataDetail.id,
                    `ĐƠT_CTKT_${dataDetail?.id || ""}`,
                    "blob",
                    ".xlsx",
                    TYPE_REPORT.TAX_DEDUCT
                  )
                );
              }}
            >
              <i
                className={` ${
                  loadingDownload ? "bx bx-loader bx-spin " : "bx bx-download "
                } label-icon`}
                style={{
                  background: "transparent",
                }}
              ></i>
              Download file đã upload
            </Button>
          </ModalFooter>
        </React.Fragment>
      </Modal>
    </React.Fragment>
  );
};

DetailReport.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  dataDetail: PropTypes.object,
  t: PropTypes.any,
  resetListData: PropTypes.func,
};

DetailReport.defaultProps = {
  isOpenModal: false,
};

export default DetailReport;
